import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    '& .MuiDialog-paper': {
      borderRadius: 32,
    },
  },
  content: {
    width: '100%',
    height: '100%',
    minWidth: 360,
  },
  title: {
    fontSize: 16,
    fontWeight: 700,
    textTransform: 'uppercase',
    textAlign: 'center',
  },
  closeButton: {
    position: 'absolute',
    top: 8,
    right: 8,
  },
  listText: {
    textAlign: 'center',
    fontWeight: 400,
  },
  selected: {
    color: theme.palette.primary.main,
    fontWeight: 700,
  },
}));
